import React from 'react';
import { Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useAuth } from '../../auth/authcontext';

interface DeleteOptionGroupProps {
    selectedMogGuid: string;
    handleDeleteMenuOptionGroup: () => void;
}

const DeleteOptionGroup: React.FC<DeleteOptionGroupProps> = ({
    selectedMogGuid,
    handleDeleteMenuOptionGroup,
}) => {
    const { isReadOnly } = useAuth();
    if (isReadOnly || !selectedMogGuid) return null;

    return (
        <Popconfirm
            title="Delete Option Group"
            description="Are you sure to remove this group from all Menu items that are currently assigned, delete all options, and the group?"
            onConfirm={handleDeleteMenuOptionGroup}
            okText="Yes"
            cancelText="No"
        >
            <Button
                danger
                size="small"
                style={{ marginLeft: 'auto', fontSize: '12px' }}
                icon={<DeleteOutlined />}
            >
                Delete Group
            </Button>
        </Popconfirm>
    );
};

export default DeleteOptionGroup;